import React from 'react'

export type Optional<T> = T | undefined

export type Voidable<T> = T | ''

export type Callbacks<T = () => void> = Record<string, T>

export const typedMemo: <T>(c: T) => T = React.memo

export type FiscalCode = {
  name: string
  surname: string
  birthDate: string
  gender: 'M' | 'F'
  birthPlace: string
}

export type ReactSelectOption = {
  value: string
  label: string
}

export type Multilanguage = {
  it: string
  en: string
  de: string
}

export type ReactSelectMultilanguageOption = {
  value: string
  language: Multilanguage
}

